import { TemplateIcon, CursorClickIcon } from '@heroicons/react/outline';

const features = [
  {
    name: 'Loaders and Actions',
    description: (
      <>
        Simply call <code>getAuth(request)</code> to access the active user ID
        and session ID
      </>
    ),
    icon: CursorClickIcon
  },
  {
    name: 'React (Server and Client)',
    description: (
      <>
        Call <code>useUser()</code> to access profile information, or{' '}
        <code>useAuth()</code> for a signed JWT with session data
      </>
    ),
    icon: TemplateIcon
  }
];

export function RemixContexts() {
  return (
    <div className="my-10 ">
      <div className="relative mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="relative lg:grid lg:grid-cols-3 lg:gap-x-8">
          <div className="lg:col-span-1">
            <h2 className="text-3xl font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              Access user data in any Remix context
            </h2>
          </div>
          <dl className="mt-10 space-y-10 sm:grid sm:grid-cols-2 sm:gap-x-8 sm:gap-y-10 sm:space-y-0 lg:col-span-2 lg:mt-0">
            {features.map(feature => (
              <div key={feature.name}>
                <dt>
                  <div className="flex h-12 w-12 items-center justify-center rounded-md bg-clerk-blue text-white">
                    <feature.icon className="h-6 w-6" aria-hidden="true" />
                  </div>
                  <p className="mt-5 text-lg font-medium leading-6 text-gray-900">
                    {feature.name}
                  </p>
                </dt>
                <dd className="mt-2 text-base text-gray-500">
                  {feature.description}
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </div>
  );
}
